<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('shiftManagement.shift') }}
      </h1>
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-8">
            <ts-button color="info" outline @click="$router.push({ name: 'shift-management-create' })">
              {{ $t('addNew') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end"></div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td class="ts-whitespace-no-wrap">{{ record.shift_name }}</td>
          <td class="ts-whitespace-no-wrap">{{ record.shift_type }}</td>
          <td class="text-center ts-whitespace-no-wrap">{{ record.minute_allow }}</td>
          <td class="text-center ts-whitespace-no-wrap">
            <a href="#" v-tooltip="$t('tooltip.show')" class="mr-2 text-info" @click.prevent="show(record)">
              <i class="fas fa-eye"></i>
            </a>
            <a href="#" v-tooltip="$t('tooltip.edit')" class="mr-2 text-primary" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="$t('tooltip.delete')"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"> </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import ShowComponent from './show.vue'

export default {
  name: 'shift-management',
  components: {
    ShowComponent
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('hr/shiftManagement', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.shiftManagement.search
      },
      set(newValue) {
        this.$store.commit('hr/shiftManagement/SET_SEARCH', newValue)
        this.$store.commit('hr/shiftManagement/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('shiftManagement.shiftName')
        },
        {
          name: this.$t('shiftManagement.shiftType'),
          style: 'width:20%'
        },
        {
          name: this.$t('shiftManagement.minuteAllow'),
          style: 'text-align:center; width:10%'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:10%'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/shiftManagement/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    show(showData) {
      this.$modal.show(
        ShowComponent,
        {
          showData: showData
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    edit(record) {
      this.$store.commit('hr/shiftManagement/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'shift-management-edit',
        params: { id: record.shift_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('hr/shiftManagement/destroy', record.shift_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'shift-management-create') {
      this.$store.commit('hr/shiftManagement/RESET_STATE')
    }
    next()
  }
}
</script>
